import React from "react";
import Container from "../../../utils/Container";
import H2 from "../../../elements/titles/H2";
import { MdOutlineHighQuality } from "react-icons/md";
import { BiDollarCircle } from "react-icons/bi";
import { ImMagicWand } from "react-icons/im";
import { MdOutlineSecurity } from "react-icons/md";
import Span from "../../../elements/span/Span";
import CategoryProductsCarousel from "../../../utils/carousels/CategoryProductsCarousel";

const ProductsCategory = () => {
  return (
    <section className="separedSection categoryProducts mb-28">
      <Container classe="xl:border-2 xl:border-tersio xl:rounded-md">
        <div className="grid place-content-center gap-y-14 py-5 md:grid-cols-2 md:grid-rows-2 md:gap-x-4 md:gap-y-10 md:rounded-md md:border-2 md:border-tersio lg:grid-cols-4 lg:grid-rows-1 xl:rounded-none xl:border-0 xl:border-none">
          <article className="flex items-center space-x-6">
            <MdOutlineHighQuality size={65} color="#161F30" />
            <div>
              <Span classe="uppercase block">qualité</Span>
              <p className="font-nunito text-sm font-normal text-secondary">
                Machines de dernières génération
              </p>
            </div>
          </article>

          <article className="flex items-center space-x-6 ">
            <BiDollarCircle size={60} color="#161F30" />
            <div>
              <Span classe="uppercase block">Prix abordable</Span>
              <p className="font-nunito text-sm font-normal text-secondary">
                À partir de 50 0000fcfa
              </p>
            </div>
          </article>

          <article className="flex items-center space-x-6 pl-2">
            <ImMagicWand color="#161F30" size={47} />
            <div>
              <Span classe="uppercase block">Customisation</Span>
              <p className="font-nunito text-sm font-normal text-secondary">
                Ajout des péripheriques adaptés
              </p>
            </div>
          </article>

          <article className="flex items-center space-x-6">
            <MdOutlineSecurity color="#161F30" size={50} />
            <div>
              <Span classe="uppercase block">Fiabilité</Span>
              <p className="font-nunito text-sm font-normal text-secondary">
                A utiliser pendant des années
              </p>
            </div>
          </article>
        </div>
      </Container>

      <Container classe="separedSection">
        <H2 classe="text-center">Catégories des produits</H2>
        <CategoryProductsCarousel />
      </Container>
    </section>
  );
};

export default ProductsCategory;
